import { FunctionComponent, useCallback, useState } from "react";
import Keyframes from "../../theme/keyframes";
import variables from "../../theme/variables";
import Rarity from "../../types/Rarity";
import ITrainer from "../../types/Trainer";
import ImagesUtils from "../../utils/images";
import UpgradeTrainer from "../UpgradeTrainer";
import S from "./styled";
import BonusTeam from "../BonusTeam";
import useWindowSize from "hooks/useWindowSize";
import TrainerType from "../TrainerType";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TrainerDetails from "./TrainerDetails/TrainerDetails";
import TrainerBonusType from "components/TrainerBonusType/TrainerBonusType";

type Props = {
  data: ITrainer;
  onClick?: (trainer: ITrainer) => any;
  updateLevel?: (level: ITrainer) => any;
  disableHover?: boolean;
  disableUpgrade?: boolean;
  comboEvent?: boolean;
};

const Trainer: FunctionComponent<Props> = ({
  data,
  onClick,
  disableHover,
  disableUpgrade,
  comboEvent,
  updateLevel,
}) => {
  const [showModal, setShowModal] = useState(false);

  const { level } = data;

  const { width } = useWindowSize();

  const trainerImage = ImagesUtils.getTrainerImage(data.name);

  const color = variables.COLORS.RARITY[data.rarity as Rarity];
  const imageBackground = `radial-gradient(${color.normal}, ${color.dark})`;

  const isShiny = [Rarity.UR, Rarity.SSR].includes(data.rarity as Rarity);
  const keyframe = isShiny ? Keyframes.gradient() : undefined;

  const getStyle = useCallback(() => {
    const style: any = {
      backgroundImage: `radial-gradient(${color.dark}, ${color.light})`,
    };

    if (isShiny) {
      style.boxShadow = `0 0 20px 0 ${color.normal}45`;
    }

    return style;
  }, []);

  const onLevelClick = (_level: number) => {
    if (disableUpgrade) {
      return;
    }

    if (_level === level && level > 1) {
      data.level -= 1;
    } else {
      data.level = _level;
    }

    updateLevel(data);
  };

  const onTrainerClick = () => {
    if (onClick) {
      onClick(data);
    }
  };

  return (
    <S.Container keyframe={keyframe} style={getStyle()} disableHover={disableHover || width < 600}>
      <S.Trainer>
        <S.Image
          style={{
            backgroundImage: imageBackground,
            cursor: onClick && "pointer",
          }}
          onClick={onTrainerClick}
        >
          <div
            style={{
              width: "100%",
              paddingTop: "100%",
              backgroundImage: `url(${trainerImage})`,
              backgroundSize: "cover",
            }}
          ></div>
          {/* <img src={trainerImage} alt={data.name} /> */}

          {comboEvent && <S.ComboEvent></S.ComboEvent>}

          <S.Team>{data.bonusTeam && <BonusTeam teams={data.bonusTeam} />}</S.Team>
        </S.Image>

        <S.Details>
          <S.Type>
            <TrainerType types={data.type} />
          </S.Type>
          <div>
            <TrainerBonusType trainer={data} />
          </div>
          <S.Position>{data.position}</S.Position>
        </S.Details>
        <S.Levels>
          {Array.from(Array(5)).map((_, i) => (
            <div key={i} onClick={onLevelClick.bind(null, i + 1)} style={{ cursor: "pointer" }}>
              <UpgradeTrainer active={i <= level - 1} />
            </div>
          ))}
        </S.Levels>
        <S.Name onClick={onTrainerClick} style={{ cursor: onClick && "pointer" }}>
          {data.name}
        </S.Name>
        <S.TrainerDetailsButton onClick={setShowModal.bind(null, true)}>
          Details{" "}
          <span>
            <FontAwesomeIcon icon={faPlusSquare} />
          </span>
        </S.TrainerDetailsButton>
      </S.Trainer>

      {showModal && <TrainerDetails onClose={setShowModal.bind(null, false)} data={data} />}
    </S.Container>
  );
};

export default Trainer;
